import { render } from "./campaign-settings.vue?vue&type=template&id=d2230190"
import script from "./campaign-settings.vue?vue&type=script&lang=js"
export * from "./campaign-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__